import React from "react";
import {
  fade,
  makeStyles,
  useTheme,
  ThemeProvider,
  createMuiTheme,
} from "@material-ui/core/styles";
import clsx from "clsx";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import InputBase from "@material-ui/core/InputBase";
import Badge from "@material-ui/core/Badge";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import MenuIcon from "@material-ui/icons/Menu";
import SearchIcon from "@material-ui/icons/Search";
import DirectionsBoatIcon from "@material-ui/icons/DirectionsBoat";
import PlaylistAddCheckIcon from "@material-ui/icons/PlaylistAddCheck";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import ForumIcon from "@material-ui/icons/Forum";
import FormatListNumberedIcon from "@material-ui/icons/FormatListNumbered";
import AccountCircle from "@material-ui/icons/AccountCircle";
import DashboardIcon from "@material-ui/icons/Dashboard";
import MailIcon from "@material-ui/icons/Mail";
import BusinessIcon from "@material-ui/icons/Business";
import ExploreIcon from "@material-ui/icons/Explore";
import GroupWorkIcon from "@material-ui/icons/GroupWork";
import NotificationsIcon from "@material-ui/icons/Notifications";
import MoreIcon from "@material-ui/icons/MoreVert";
import FlagIcon from "@material-ui/icons/Flag";
import WavesIcon from "@material-ui/icons/Waves";
import EditLocationIcon from "@material-ui/icons/EditLocation";
import EventIcon from "@material-ui/icons/Event";
import SpellcheckIcon from "@material-ui/icons/Spellcheck";
import RouterIcon from "@material-ui/icons/Router";
import WbSunnyIcon from "@material-ui/icons/WbSunny";
import PeopleIcon from "@material-ui/icons/People";
import Drawer from "@material-ui/core/Drawer";
import CssBaseline from "@material-ui/core/CssBaseline";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import StarBorder from "@material-ui/icons/StarBorder";
import Box from '@material-ui/core/Box';
import { viVN } from "@material-ui/core/locale";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
//--user components
import MapViewControl from "./MapViewControl";
import SuKienPage from "./SuKienPage";
import KeHoachTauPage from "./KeHoachTauPage";
import TrucBanPage from "./TrucBanPage";
import ThongKePage from "./ThongKePage";
import ChatOnlinePage from "./ChatOnlinePage";
import localConfig from "local-storage";
import CoQuanPage from "./danhmuc/CoQuanPage";
import DoiTacPage from "./danhmuc/DoiTacPage";
import LoaiTauPage from "./danhmuc/LoaiTauPage";
import QuocGiaPage from "./danhmuc/QuocGiaPage";
import TaiNanPage from "./danhmuc/TaiNanPage";
import VungBienPage from "./danhmuc/VungBienPage";
import KhuVucPage from "./danhmuc/KhuVucPage";
import TauSarPage from "./danhmuc/TauSarPage";
import ThietBiPage from "./danhmuc/ThietBiPage";
import TaiKhoanPage from "./danhmuc/TaiKhoanPage";
import { globalEval } from "jquery";
import { Button, InputLabel } from "@material-ui/core";
import MyButton from "./MyButton";
import TestPage from './TestPage';
const drawerWidth = 190;
const server = require("../lib/server");

const updateSoTinNhan = (callback) => {
  if (global.updateSoTinNhan === undefined) {
    global.updateSoTinNhan = callback;
  }
  //truy van so tin nhan
  server
    .query("chat/getUnread")
    .then((response) => {
      callback(response);
    })
    .catch((error) => console.log(error));
};

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth + 2}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(1)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "1ch",
    },
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "center",
    flexShrink: 0,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    height: '90vh',
    padding: theme.spacing(0),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: 0,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: drawerWidth,
  },
  bottomPush: {
    position: "fixed",
    bottom: 0,
    textAlign: "center",
    paddingBottom: 5,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  drawerRoot: {
    minWidth: "32px !important",
  },
}));
function getSavedConfig() {
  let currentPage = localConfig.get("currentPage");
  let open = localConfig.get("drawerOpened");
  console.log(currentPage, open);
  return {
    currentPage:
      currentPage === undefined || currentPage === null ? "bando" : currentPage,
    drawerOpened: open === undefined || open === null || open === "true",
  };
}
function getTitle(page) {
  return page === "bando"
    ? "Bản đồ Tìm kiếm cứu nạn"
    : page === "quanly"
    ? "Quản lý sự vụ"
    : page === "thongke"
    ? "Thống kê số liệu"
    : page === "kehoachtau"
    ? "Kế hoạch chốt chặn"
    : page === "trucban"
    ? "Sổ trực ban"
    : page === "chat"
    ? "Trao đổi thông tin"
    : page === "coquan"
    ? "Danh mục Cơ quan"
    : page === "doitac"
    ? "Danh mục Đơn vị ngoài"
    : page === "loaitau"
    ? "Danh mục Loại tàu"
    : page === "quocgia"
    ? "Danh mục Quốc gia"
    : page === "tainan"
    ? "Danh mục Tính chất tai nạn"
    : page === "vungbien"
    ? "Danh mục vùng biển"
    : page === "khuvuc"
    ? "Danh mục Khu vực biển"
    : page === "tausar"
    ? "Danh mục tên tàu SAR"
    : page === "thietbi"
    ? "Danh mục loại thiết bị"
    : page === "nguoidung"
    ? "Tài khoản người sử dụng"
    : "";
}
const default_theme = {
  spacing: 4,
  typography: {
    // In Chinese and Japanese the characters are usually larger,
    // so a smaller fontsize may be appropriate.
    fontSize: 12,
  },
};
export default function HomePage(props) {
  //const theme = useTheme();
  const theme = createMuiTheme(default_theme, viVN);
  const classes = useStyles(theme);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  const [state, setState] = React.useState(getSavedConfig());

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = (action) => {
    setAnchorEl(null);
    handleMobileMenuClose();
    if (action === "exit") {
      window.sessionStorage.setItem("JWT", undefined);
      global.User = {};
      props.onExit();
    }
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const [openDrawer, setOpenDrawer] = React.useState(state.drawerOpened);
  const toogleDrawer = () => {
    setOpenDrawer(!openDrawer);
    localConfig.set("drawerOpened", !openDrawer + "");
  };
  const [openDanhmuc, setOpenDanhmuc] = React.useState(false);

  const handleDanhmucClick = () => {
    setOpenDanhmuc(!openDanhmuc);
  };
  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={() => handleMenuClose("exit")}>Thoát</MenuItem>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <IconButton aria-label="show 11 new notifications" color="inherit">
          <Badge badgeContent={11} color="secondary">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );
  const mapDiv = (
    <div
      id="map"
      style={{ width: "100%", height: "80vh", minHeight: "100%" }}
    ></div>
  );

  const [mapControl, setMapControl] = React.useState(undefined);
  const [soTinNhan, setSoTinNhan] = React.useState(0);
  const [divMapHeight, setDivMapHeight] = React.useState(500);
  var mainDiv = React.useRef();
  // Similar to componentDidMount and componentDidUpdate:
  React.useEffect(() => {
    // Update the document title using the browser API
    updateSoTinNhan(setSoTinNhan);
    console.log("main div", mainDiv.current.offsetHeight);
    setDivMapHeight(mainDiv.current.offsetHeight);

  });
  return (
    <ThemeProvider theme={theme}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
          <AppBar
            position="static"
            className={clsx(classes.appBar, {
              [classes.appBarShift]: openDrawer,
            })}
          >
            <Toolbar>
              <IconButton
                edge="start"
                className={classes.menuButton}
                color="inherit"
                aria-label="open drawer"
                onClick={toogleDrawer}
              >
                <MenuIcon />
              </IconButton>
              <Typography className={classes.title} variant="h6" noWrap>
                {getTitle(state.currentPage)}
              </Typography>
              <div className={classes.grow} />
              <div className={classes.sectionDesktop}>
                <IconButton
                  aria-label="show 17 new notifications"
                  color="inherit"
                  onClick={() => {
                    updateSoTinNhan(setSoTinNhan);
                  }}
                >
                  <Badge badgeContent={soTinNhan} color="secondary">
                    <NotificationsIcon />
                  </Badge>
                </IconButton>
                <MyButton
                  edge="end"
                  aria-label="account of current user"
                  aria-controls={menuId}
                  aria-haspopup="true"
                  onClick={handleProfileMenuOpen}
                  color="primary"
                  icon={<AccountCircle />}
                  text={global.User.UserName}
                ></MyButton>
              </div>
              <div className={classes.sectionMobile}>
                <IconButton
                  aria-label="show more"
                  aria-controls={mobileMenuId}
                  aria-haspopup="true"
                  onClick={handleMobileMenuOpen}
                  color="inherit"
                >
                  <MoreIcon />
                </IconButton>
              </div>
            </Toolbar>
          </AppBar>
          {renderMobileMenu}
          {renderMenu}
          {/**Drawer - thanh cong cu ben trai */}
            <Drawer
              className={classes.drawer}
              variant="persistent"
              anchor="left"
              open={openDrawer}
              classes={{
                paper: classes.drawerPaper,
              }}
            >
              <div className={classes.drawerHeader}>
                <img
                  src={require("../logo.jpg")}
                  alt="logo"
                  className={classes.logo}
                />
              </div>
              <Divider />
              <List>
                {[
                  {
                    title: "Bản đồ",
                    id: "bando",
                    icon: <ExploreIcon color="primary" />,
                  },
                  {
                    title: "Quản lý sự vụ",
                    id: "quanly",
                    icon: <DirectionsBoatIcon color="primary" />,
                  },
                  {
                    title: "Kế hoạch chốt chặn",
                    id: "kehoachtau",
                    icon: <PlaylistAddCheckIcon color="primary" />,
                  },
                  {
                    title: "Sổ trực ban",
                    id: "trucban",
                    icon: <MenuBookIcon color="primary" />,
                  },
                  {
                    title: "Trao đổi thông tin",
                    id: "chat",
                    icon: <ForumIcon color="primary" />,
                  },
                  {
                    title: "Thống kê",
                    id: "thongke",
                    icon: <FormatListNumberedIcon color="primary" />,
                  },
                ].map((item, index) => (
                  <ListItem
                    button
                    key={item.id}
                    onClick={() => {
                      localConfig.set("currentPage", item.id);
                      setState({ currentPage: item.id });
                    }}
                  >
                    <ListItemIcon
                      classes={{
                        root: classes.drawerRoot,
                      }}
                    >
                      {item.icon ? item.icon : <MailIcon color="primary" />}
                    </ListItemIcon>
                    <ListItemText primary={item.title} />
                  </ListItem>
                ))}
              </List>
              <Divider />
              <List>
                <ListItem button key={"danhmuc"} onClick={handleDanhmucClick}>
                  <ListItemIcon
                    classes={{
                      root: classes.drawerRoot,
                    }}
                  >
                    <DashboardIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Danh mục"} />
                  {openDanhmuc ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={openDanhmuc} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItem
                      button
                      className={classes.nested}
                      onClick={() => setState({ currentPage: "coquan" })}
                    >
                      <ListItemIcon
                        classes={{
                          root: classes.drawerRoot,
                        }}
                      >
                        <BusinessIcon />
                      </ListItemIcon>
                      <ListItemText primary="Cơ quan" />
                    </ListItem>
                    <ListItem
                      button
                      className={classes.nested}
                      onClick={() => setState({ currentPage: "doitac" })}
                    >
                      <ListItemIcon
                        classes={{
                          root: classes.drawerRoot,
                        }}
                      >
                        <GroupWorkIcon />
                      </ListItemIcon>
                      <ListItemText primary="Đơn vị ngoài" />
                    </ListItem>
                    <ListItem
                      button
                      className={classes.nested}
                      onClick={() => setState({ currentPage: "loaitau" })}
                    >
                      <ListItemIcon
                        classes={{
                          root: classes.drawerRoot,
                        }}
                      >
                        <DirectionsBoatIcon />
                      </ListItemIcon>
                      <ListItemText primary="Loại tàu" />
                    </ListItem>
                    <ListItem
                      button
                      className={classes.nested}
                      onClick={() => setState({ currentPage: "quocgia" })}
                    >
                      <ListItemIcon
                        classes={{
                          root: classes.drawerRoot,
                        }}
                      >
                        <FlagIcon />
                      </ListItemIcon>
                      <ListItemText primary="Quốc gia" />
                    </ListItem>
                    <ListItem
                      button
                      className={classes.nested}
                      onClick={() => setState({ currentPage: "vungbien" })}
                    >
                      <ListItemIcon
                        classes={{
                          root: classes.drawerRoot,
                        }}
                      >
                        <WavesIcon />
                      </ListItemIcon>
                      <ListItemText primary="Vùng biển" />
                    </ListItem>
                    <ListItem
                      button
                      className={classes.nested}
                      onClick={() => setState({ currentPage: "khuvuc" })}
                    >
                      <ListItemIcon
                        classes={{
                          root: classes.drawerRoot,
                        }}
                      >
                        <EditLocationIcon />
                      </ListItemIcon>
                      <ListItemText primary="Khu vực biển" />
                    </ListItem>
                    <ListItem
                      button
                      className={classes.nested}
                      onClick={() => setState({ currentPage: "tainan" })}
                    >
                      <ListItemIcon
                        classes={{
                          root: classes.drawerRoot,
                        }}
                      >
                        <EventIcon />
                      </ListItemIcon>
                      <ListItemText primary="Tính chất tai nạn" />
                    </ListItem>
                    <ListItem
                      button
                      className={classes.nested}
                      onClick={() => setState({ currentPage: "tausar" })}
                    >
                      <ListItemIcon
                        classes={{
                          root: classes.drawerRoot,
                        }}
                      >
                        <SpellcheckIcon />
                      </ListItemIcon>
                      <ListItemText primary="Tên tàu SAR" />
                    </ListItem>
                    <ListItem
                      button
                      className={classes.nested}
                      onClick={() => setState({ currentPage: "thietbi" })}
                    >
                      <ListItemIcon
                        classes={{
                          root: classes.drawerRoot,
                        }}
                      >
                        <RouterIcon />
                      </ListItemIcon>
                      <ListItemText primary="Loại thiết bị" />
                    </ListItem>
                  </List>
                </Collapse>
                <ListItem
                  button
                  key={"nguoidung"}
                  onClick={() => setState({ currentPage: "nguoidung" })}
                >
                  <ListItemIcon
                    classes={{
                      root: classes.drawerRoot,
                    }}
                  >
                    <PeopleIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Người dùng"} />
                </ListItem>
              </List>
              {/*
        <div className={classes.bottomPush}>
          <Typography paragraph>
            Trung tâm Tìm kiếm cứu nạn <br /> Năm 2020
          </Typography>
        </div>
         */}
            </Drawer>
          <main
              className={clsx(classes.content, {
                [classes.contentShift]: openDrawer,
              })}
              ref={mainDiv}
            >
              {state.currentPage === "bando" && global.User.Quyen.R21 ? (
                <MapViewControl height={divMapHeight + 124} />
              ) : state.currentPage === "quanly" && global.User.Quyen.R22 ? (
                <SuKienPage />
              ) : state.currentPage === "kehoachtau" &&
                global.User.Quyen.R23 ? (
                <KeHoachTauPage />
              ) : state.currentPage === "trucban" && global.User.Quyen.R24 ? (
                <TrucBanPage />
              ) : state.currentPage === "thongke" && global.User.Quyen.R29 ? (
                <ThongKePage />
              ) : state.currentPage === "chat" && global.User.Quyen.R25 ? (
                <ChatOnlinePage />
              ) : state.currentPage === "coquan" && global.User.Quyen.R11 ? (
                <CoQuanPage />
              ) : state.currentPage === "doitac" && global.User.Quyen.R12 ? (
                <DoiTacPage />
              ) : state.currentPage === "loaitau" && global.User.Quyen.R13 ? (
                <LoaiTauPage />
              ) : state.currentPage === "quocgia" && global.User.Quyen.R14 ? (
                <QuocGiaPage />
              ) : state.currentPage === "tainan" && global.User.Quyen.R17 ? (
                <TaiNanPage />
              ) : state.currentPage === "vungbien" && global.User.Quyen.R15 ? (
                <VungBienPage />
              ) : state.currentPage === "khuvuc" && global.User.Quyen.R16 ? (
                <KhuVucPage />
              ) : state.currentPage === "tausar" && global.User.Quyen.R18 ? (
                <TauSarPage />
              ) : state.currentPage === "thietbi" && global.User.Quyen.R19 ? (
                <ThietBiPage />
              ) : state.currentPage === "nguoidung" && global.User.Quyen.R90 ? (
                <TaiKhoanPage />
              ) : (
                <div>Bạn không có quyền truy cập !</div>
              )}
            </main>
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  );
}
